import {ClientRequest} from '../../Interfaces/ClientRequest';
import {Subscription} from 'rxjs';
import {BookingsView} from '../../Interfaces/BookingsView';
import {UntypedFormBuilder, UntypedFormControl} from '@angular/forms';
import {Router} from '@angular/router';
import {SharedVarService} from '../shared-service.service';
import {AppComponent} from '../../app.component';
import {QueryService} from '../../Services/query.service';
import {User} from '../../Interfaces/User';
import {BookingAuthorization} from '../../Interfaces/BookingAuthorization';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {BookingHazardsView} from '../../Interfaces/BookingHazardsView';
import {BookingUnit} from '../../Interfaces/BookingUnit';
import NumberFormatOptions = Intl.NumberFormatOptions;
import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ListData} from '../../Interfaces/ListData';
import {GlobalEventsManager} from '../../GlobalEventManager';
import * as XLSX from 'xlsx';
import {BookingExcel} from '../../Interfaces/BookingExcel';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import moment from 'moment';


@Component({
  selector: 'app-booking-inquiry',
  templateUrl: './booking-inquiry.component.html',
  styleUrls: ['./booking-inquiry.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0', display: 'none'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})
export class BookingInquiryComponent implements OnInit, OnDestroy, AfterViewInit {
  private listData: ListData[];
  private listDataObj: ListData;
  txtFromArea: string;
  public savedList: string;
  public savedLists: { id: string, code: string, description: string }[] = [];
  myNewListName: string = "";
  weightk: string;
  weightlb: string;
  bookingNum: string;
  submitted: boolean = false;
  oneIsInAlready: boolean = false;
  didntEnterShit: boolean = false;
  badChars: boolean = false;
  badSearch: boolean = false;
  showQuickView: boolean = false;
  showDetailScreen: boolean = false;
  insertListExists: boolean = false;
  insertNoConts: boolean = false;
  noListName: boolean = false;
  txtArray2: string [] = [];
  private clientRequest: ClientRequest;
  private subscription: Subscription;
  private bookDetails: BookingsView [] = [];
  private bookDetail: BookingsView;
  private bookDetailExcelArray: BookingExcel[] = [];
  private bookDetailExcel: BookingExcel;
  private bookHaz: BookingHazardsView;
  private bookAuth: BookingAuthorization;
  private  myUser: User;
  public qvColumns: string[];
  public authColumns: string[];
  public authColumns2: string[];
  public unitColumns: string[];
  showAuthInfo: boolean = false;
  showHazardInfo: boolean = false;
  showReeferInfo: boolean = false;
  foundOne: boolean = false;
  currentIndx: number = 0;
  hazardIndx: number = 0;
  search1: UntypedFormControl;
  expandedElement: any;
  phoneApp: boolean = false;
  ipadApp: boolean = false;
  totalReserved: string;
  recColName: string;
  delColName: string;
  maherError: string;

  quickViewData: MatTableDataSource<BookingsView>;
  excelData: MatTableDataSource<BookingsView>;
  itemsData: MatTableDataSource<BookingAuthorization>;
  itemsData2: MatTableDataSource<BookingAuthorization>;
  unitData: MatTableDataSource<BookingUnit>;
  showAcc: boolean = false;


  @ViewChild(MatSort) set content(sort: MatSort) {
    if (this.quickViewData!=undefined){
      this.quickViewData.sort = sort;
    }
    if (this.itemsData!=undefined){
      this.itemsData.sort = sort;
    }
    if (this.unitData!=undefined){
      this.unitData.sort = sort;
    }
  }

  @ViewChild(MatPaginator) set content2(pag: MatPaginator) {
    if (this.quickViewData!=undefined){
      this.quickViewData.paginator = pag;
    }
    if (this.itemsData!=undefined){
      this.itemsData.paginator = pag;
    }

  }
  private options: Intl.DateTimeFormatOptions = {month: "2-digit", day: "2-digit", year: "numeric", hour: "2-digit",minute:"2-digit"};
  private options2: NumberFormatOptions = {maximumFractionDigits: 1};
  private options3: NumberFormatOptions = {maximumFractionDigits: 0};
 public tallyInDisp: string = "Tally In";
 public tallyOutDisp: string = "Tally Out";

  private  date1: Date;
  private  number1: number;
  sub: any;
  public inSearch: boolean = false;
  public ipadAppear: boolean = true;

  dontShowSearch(){
    if (this.ipadApp){
      this.inSearch = true;
      this.ipadAppear = false;
    }
  }

  returnToSearch(){
    if (this.ipadApp){
      this.inSearch = false;
      this.ipadAppear = true;
      this.showQuickView = false;
    }
  }


  showHideSearch(){
    if (this.ipadApp && !this.inSearch){
      if (this.ipadAppear){
        this.ipadAppear = false;
      }else{
        this.ipadAppear = true;
      }
    }
    this.inSearch = false;

  }


  checkForIpad(){

  }


  constructor(fb: UntypedFormBuilder,  private router: Router,private service: SharedVarService, private myApp:AppComponent,private  globalEventsManager: GlobalEventsManager, private  queryService: QueryService) {
    this.qvColumns = ["booking","line_id","booking_type","vesVoyage","vessel_visit_phase_description","quantity","tally_in","tally_out","receive_completeFmt","deliver_completeFmt","hazardousFmt","reeferFmt","created_date_fmt"];
    this.authColumns = ["description","grade_description","qty","delivered_qty","delivered_balance","rcv_limit","received_qty","received_balance","reservedCount"];
    this.authColumns2 = ["description2","qty","delivered_qty","received_qty"];
    this.unitColumns = ["unit_id","line_id","moveType"];


    this.sub =  this.service.getConfirmed().subscribe((value) => {
      if (value){
        this.updateContainerList('D');
        this.service.setConfirmed(false);
      }
    });




    this.myUser = this.myApp.user;
/*
        this.myUser = {} as User;
        this.myUser.active ="Y"
        this.myUser.address_1 = "15600 JFK BLVD. Suite 400"
        this.myUser.address_2 = null
        this.myUser.company_code ="EGN"
       // this.myUser.company_code ="M0995"
        this.myUser.company_name= "MAHER TERMINALS, LLC"
        this.myUser.city= "HOUSTON"
        this.myUser.email_address= null
        this.myUser.fax_number= null
        this.myUser.first_name= "Csp Craig"
        this.myUser.last_name= "Miller"
        this.myUser. maherError= null
        this.myUser.old_password= null
        this.myUser.password= ""
        this.myUser.phone_number= null
        this.myUser.company_scac= null
        this.myUser.state= "TX"
        this.myUser.userMenuReportItemsView= null
        this.myUser.user_gkey= "8237887"
     //   this.myUser.role= "AGENT"
       this.myUser.role= "LINEOP"
     //   this.myUser.role= "HAULIER"
        this.myUser.username="CSPSSL"
        this.myUser.zip="07201"
        this.myUser.canSeeAllData = "0";


 */





  }


  exportExcel() {
    this.bookDetailExcelArray = [];
    for (var xx=0; xx<this.quickViewData.filteredData.length; xx++){
      this.bookDetailExcel = {} as BookingExcel ;
      this.bookDetailExcel.Booking = this.quickViewData.filteredData[xx].booking;
      this.bookDetailExcel.SSL = this.quickViewData.filteredData[xx].line_id_description;
      this.bookDetailExcel.Type = this.quickViewData.filteredData[xx].booking_type;
      this.bookDetailExcel.VesselVoyage = this.quickViewData.filteredData[xx].vesVoyage;
      this.bookDetailExcel.Phase = this.quickViewData.filteredData[xx].vessel_visit_phase_description;
      this.bookDetailExcel.Quantity = this.quickViewData.filteredData[xx].quantity;
      this.bookDetailExcel.TallyIn = this.quickViewData.filteredData[xx].tally_in;
      this.bookDetailExcel.TallyOut = this.quickViewData.filteredData[xx].tally_out;
      this.bookDetailExcel.ReceivedComplete = this.quickViewData.filteredData[xx].receive_completeFmt;
      this.bookDetailExcel.DeliveredComplete = this.quickViewData.filteredData[xx].deliver_completeFmt;
      this.bookDetailExcel.Hazardous = this.quickViewData.filteredData[xx].hazardousFmt;
      this.bookDetailExcel.Reefer = this.quickViewData.filteredData[xx].reeferFmt;
      this.bookDetailExcel.Created = this.quickViewData.filteredData[xx].created_date_fmt;

      this.bookDetailExcelArray.push(this.bookDetailExcel);

    }
    const workSheet = XLSX.utils.json_to_sheet(this.bookDetailExcelArray );
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    var wscols = [
      {wch:15},
      {wch:20},
      {wch:10},
      {wch:30},
      {wch:10},
      {wch:10},
      {wch:10},
      {wch:10},
      {wch:15},
      {wch:15},
      {wch:10},
      {wch:10},
      {wch:20},
    ];
    workSheet['!cols'] = wscols;
    XLSX.utils.book_append_sheet(workBook, workSheet, 'BookingInquiry');
    XLSX.writeFile(workBook, 'bookingInquiry.xlsx');
  }


  ngOnInit() {
    this.search1 = new UntypedFormControl();
    this.getListData();
    this.bookDetail = {} as BookingsView;

    if (window.innerWidth > 750 && window.innerWidth <1150){
      this.ipadApp = true;
    }
    if (window.innerWidth <= 750){
      this.phoneApp = true;
    }

  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getSearchItems(){

    if (this.oneIsInAlready){
      return;
    }

    this.showQuickView = false;
    this.showDetailScreen = false;
    this.submitted = true;
    this.oneIsInAlready = true;
    this.badSearch = false;
    this.didntEnterShit = false;
    this.badChars = false;
    if (this.txtFromArea == undefined) {
      this.didntEnterShit = true;
      this.oneIsInAlready = false;
      return;
    }

    this.txtFromArea = this.txtFromArea.replace(" ",'\n');
    this.txtFromArea = this.txtFromArea.replace(" ",'\n');
    this.txtFromArea = this.txtFromArea.replace(" ",'\n');
    this.txtFromArea = this.txtFromArea.replace(" ",'\n');
    this.txtFromArea = this.txtFromArea.replace(" ",'\n');


    this.txtArray2 = this.txtFromArea.split(/[\r\n]+/);
    if (this.txtArray2.length == 0) {
      this.didntEnterShit = true;
      this.oneIsInAlready = false;
      return;
    }
    this.didntEnterShit = false;
    var _i = this.txtArray2.length;
    while (_i--) {
      this.txtArray2[_i] = this.txtArray2[_i].valueOf().trim();
      if (!this.service.checkForSpecialChars(this.txtArray2[_i].valueOf())) {
        this.bookingNum = this.txtArray2[_i].valueOf();
        this.badChars = true;
        this.oneIsInAlready = false;
        return;
      }

      if (this.txtArray2[_i].valueOf() == "") {
        this.txtArray2.splice(_i, 1);
      }
    }
    if (this.txtArray2.length == 0) {
      this.didntEnterShit = true;
      this.oneIsInAlready = false;
      return;
    }

    this.txtArray2 = this.service.onlySendOneHundread(this.txtArray2);

    this.didntEnterShit = false;
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.bookDetail = {} as BookingsView;
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];
    this.bookDetails = [];
    for (var items of this.txtArray2){
      this.bookDetail = {} as BookingsView;
      this.bookDetail.booking = items.valueOf();
      this.bookDetails.push(this.bookDetail);
    }
    this.clientRequest.requestData = this.bookDetails;

    this.clearAllInfo();

    var lhsUserObs$ = this.queryService.getBookings(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (book) => {
        this.bookDetails = book;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
        this.maherError = null;
        this.submitted = false;
        this.oneIsInAlready = false;

        if (this.bookDetails.length>0) {
          if (this.bookDetails.length == 1) {
            if (this.bookDetails[0].maherError !=null) {
              this.maherError = this.bookDetails[0].maherError;
            } else {
              this.bookDetail = this.bookDetails[0];
              this.currentIndx = 0;
              this.hazardIndx= 0;
              this.formatDetailScreen();
              this.showQuickView = false;
              this.showDetailScreen = true;
            }
          } else {
            for (var item of this.bookDetails){
              if (item.maherError != null) {
                item.vesVoyage = item.maherError;
              }else{
                if (item.booking_type=="BOOK"){
                  item.vesVoyage = item.vessel_description + " / " + item.ob_vyg;
                }
                if (item.quantity!=null){
                  item.quantity = this.getNiceNumber(item.quantity);
                }
                if (item.tally_in!=null){
                  item.tally_in = this.getNiceNumber(item.tally_in);
                }
                if (item.tally_out!=null){
                  item.tally_out = this.getNiceNumber(item.tally_out);
                }

                if (item.receive_complete=="0"){
                  item.receive_completeFmt = "No";
                }else{
                  item.receive_completeFmt = "Yes";
                }
                if (item.deliver_complete=="0"){
                  item.deliver_completeFmt = "No";
                }else{
                  item.deliver_completeFmt = "Yes";
                }
                if (item.hazardous=="0"){
                  item.hazardousFmt = "No";
                }else{
                  item.hazardousFmt = "Yes";
                }
                if (item.reefer=="0"){
                  item.reeferFmt = "No";
                }else{
                  item.reeferFmt = "Yes";
                }
                item.created_date = this.getNiceDateTime(item.created_date);
                item.vessel_visit_phaseNum = Number.parseInt(item.vessel_visit_phase);

              }




            }

            this.showQuickView = true;
            this.showDetailScreen = false;
            this.search1.reset();
            if (this.ipadApp){
              this.recColName = "Recv.";
              this.delColName = "Delv."
            }else{
              this.recColName = "Recv. Comp";
              this.delColName = "Delv. Comp";
            }
            if (window.innerWidth > 750 && window.innerWidth <1150){
              this.ipadAppear = false;
              this.tallyInDisp = "T/In";
              this.tallyOutDisp = "T/Out";
            }else{
              this.tallyInDisp = "Tally In";
              this.tallyOutDisp = "Tally Out";
            }

            this.quickViewData = new MatTableDataSource<BookingsView>(this.bookDetails);
            this.quickViewData.sortingDataAccessor = (item, property) => {
              switch (property) {
                case 'quantity':
                  return parseInt(item.quantity.replace(/,/g, ''));
                case 'tally_in':
                  return parseInt(item.tally_in.replace(/,/g, ''));
                case 'tally_out':
                  return parseInt(item.tally_out.replace(/,/g, ''));
                case 'created_date_fmt':
                  return new Date(item.created_date_fmt);
                default:
                  return item[property];
              }
            };
          }
        }else{
          this.badSearch = true;
        }


      });

    //  }
  }

  getNiceNumber(weightIn: string): string {
    this.number1 = Number.parseInt(weightIn);
    return this.number1.toLocaleString("en-US", this.options3);
  }


  getNiceWeight(weightIn: string): string {
    this.number1 = Number.parseInt(weightIn);
    return this.number1.toLocaleString("en-US", this.options2);
  }

  getNiceDateTime2(): string {
    this.date1 =  new Date();
    return this.date1.toLocaleDateString("en-US", this.options);
  }

  getNiceDateTime(dateIn: string): string {
    dateIn = moment(dateIn).format("YYYY-MM-DD hh:mm:ss");
    this.date1 = null;
    this.date1 =  new Date(dateIn.replace(/-/g, '/'));
    return this.date1.toLocaleDateString("en-US", this.options);
  }

  clearAllInfo(){
    this.showAuthInfo = false;
    this.showReeferInfo = false;
    this.showHazardInfo = false;

  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    this.quickViewData.filter = filterValue;
  }


  isBeforeToday(timeIn: string): boolean {
    let newDate = new Date(this.getNiceDateTime2());
    let newDate2 = new Date(this.getNiceDateTime(timeIn));

    if (newDate2 < newDate){
      return true;
    }
    return false;
  }

  expandThatShit(rowIn: BookingAuthorization){
    this.showReeferInfo = false;
    if (rowIn.expanded=='N'){
      for (var item of this.bookDetail.bookingItemViews) {
        item.expanded = "N";
      }
    }
    if (rowIn.expanded == 'N'){
      rowIn.expanded = 'Y';
    }else{
      rowIn.expanded = 'N';
    }
    if (rowIn.temp_required_c!=null){
      this.showReeferInfo = true;
    }
    this.bookAuth = rowIn;
    if (this.bookAuth.created_date == null) {
      this.bookAuth.created_fmt = " ";
    }else{
      this.bookAuth.created_fmt = this.getNiceDateTime(this.bookAuth.created_date);
    }
    if (this.bookAuth.changed_date == null) {
      this.bookAuth.changed_fmt = " ";
    }else{
      this.bookAuth.changed_fmt = this.getNiceDateTime(this.bookAuth.changed_date);
    }

    for (var items of this.bookAuth.bookingUnits){
      if (items.received=="1"){
        items.moveType = "Received";
      }else if (items.delivered=="1"){
        items.moveType = "Delivered";
      }else if (items.reserved=="1"){
        items.moveType = "Reserved";
      }



    }

    this.unitData = new MatTableDataSource<BookingUnit>(this.bookAuth.bookingUnits);

    this.expandedElement === rowIn? this.expandedElement = null : this.expandedElement = rowIn;
  }


  showDetails(rowIn: BookingsView){
    if (rowIn.maherError != null) {
      return;
    }
    this.currentIndx = this.bookDetails.findIndex(xx => xx.booking == rowIn.booking);
    this.hazardIndx = 0;
    this.showQuickView = false;
    this.showDetailScreen = true;
    this.showAcc = false;
    this.bookDetail = null;
    this.bookDetail = {} as BookingsView;
    this.bookDetail = rowIn;
    this.formatDetailScreen();
  }

  returnToQuery(){
    this.showQuickView = false;
    this.showDetailScreen = false;
  }

  returnToQuickView(){
    this.showQuickView = true;
    this.showDetailScreen = false;
  }



  nextHazard(){
    this.hazardIndx++;
    if (this.hazardIndx<this.bookDetail.bookingHazardsViews.length){
      this.bookHaz = null;
      this.bookHaz = {} as BookingHazardsView;
      this.bookHaz = this.bookDetail.bookingHazardsViews[this.hazardIndx];
      this.formatHazards(this.hazardIndx);
    }else{
      this.hazardIndx=this.bookDetail.bookingHazardsViews.length-1;
      var _i = this.bookDetails.length;
    }
  }

  previousHazard(){
    this.hazardIndx--;
    if (this.hazardIndx>=0){
      this.bookHaz = null;
      this.bookHaz = {} as BookingHazardsView;
      this.bookHaz = this.bookDetail.bookingHazardsViews[this.hazardIndx];
      this.formatHazards(this.hazardIndx);
    }else{
      this.hazardIndx=0;
    }


  }



  nextTransaction(){
    this.foundOne = false;
    var currentIdx = this.currentIndx;
    this.currentIndx++;
    if (this.currentIndx<this.bookDetails.length){
      for (var dd=this.currentIndx; dd<this.bookDetails.length; dd++){
        if (this.bookDetails[dd].maherError!=null ) {
          this.currentIndx++;
          this.foundOne = false;
        }else{
          this.foundOne = true;
          break;
        }
      }
      if (!this.foundOne){
        this.currentIndx = currentIdx;
      }

      this.bookDetail = null;
      this.bookDetail = {} as BookingsView;
      this.bookDetail = this.bookDetails[this.currentIndx];
      this.clearAllInfo();
      this.showAcc = false;
      this.formatDetailScreen();
    }else{
      this.currentIndx=this.bookDetails.length-1;
      var _i = this.bookDetails.length;
      while (_i--) {
        if (this.bookDetails[_i].maherError !=null) {
        } else {
          this.currentIndx = _i;
          break;
        }
      }
    }
  }

  previousTransaction(){
    this.currentIndx--;
    if (this.currentIndx>=0){
      for (var dd=this.currentIndx; dd<this.bookDetails.length; dd--){
        if (this.bookDetails[dd].maherError!= null) {
          this.currentIndx--;
        }else{
          break;
        }
      }
      this.bookDetail = null;
      this.bookDetail = {} as BookingsView;
      this.bookDetail = this.bookDetails[this.currentIndx];
      this.clearAllInfo();
      this.showAcc = false;
      this.formatDetailScreen();
    }else{
      this.currentIndx=0;
    }


  }


  formatDetailScreen() {
    this.totalReserved = "0";
    if (this.bookDetail.booking == null) {
      this.bookDetail.booking = " ";
    }
    if (this.bookDetail.line_id_description == null) {
      this.bookDetail.line_id_description = " ";
    }
    if (this.bookDetail.booking_type == null) {
      this.bookDetail.booking_type = " ";
    }
    if (this.bookDetail.notes == null) {
      this.bookDetail.notes = " ";
    }
    if (this.bookDetail.shipper == null) {
      this.bookDetail.shipper = " ";
    }
    if (this.bookDetail.consignee == null) {
      this.bookDetail.consignee = " ";
    }
    if (this.bookDetail.vessel_description == null) {
      this.bookDetail.vessel_description = " ";
    }
    if (this.bookDetail.ob_vyg == null) {
      this.bookDetail.ob_vyg = " ";
    }
    if (this.bookDetail.eta == null) {
      this.bookDetail.eta_fmt = " ";
    }

    if (this.bookDetail.begin_auto_receive == null) {
      this.bookDetail.begin_auto_receive_fmt = " ";
    }


    if (this.bookDetail.auto_cutoff == null) {
      this.bookDetail.auto_cutoff_fmt = " ";
    }

    if (this.bookDetail.hazardous_cutoff == null) {
      this.bookDetail.hazardous_cutoff_fmt = " ";
    }

    if (this.bookDetail.begin_receive == null) {
      this.bookDetail.begin_receive_fmt = " ";
    }

    if (this.bookDetail.cargo_cutoff == null) {
      this.bookDetail.cargo_cutoff_fmt = " ";
    }

    if (this.bookDetail.port_of_loading_description == null) {
      this.bookDetail.port_of_loading_description = " ";
    }
    if (this.bookDetail.port_of_discharge_description == null) {
      this.bookDetail.port_of_discharge_description = " ";
    }
    if (this.bookDetail.port_of_destination_description == null) {
      this.bookDetail.port_of_destination_description = " ";
    }

    if (this.bookDetail.utcsView != null) {
      if (this.bookDetail.utcsView.truckername == null) {
        this.bookDetail.utcsView.truckername = " ";
      }
      if (this.bookDetail.utcsView.trucklinestatus == null) {
        this.bookDetail.utcsView.trucklinestatus = " ";
      }
      if (this.bookDetail.utcsView.lifecyclestatedescription == null) {
        this.bookDetail.utcsView.lifecyclestatedescription = " ";
      }

      if (this.bookDetail.utcsView.insuranceexpirationdate == null) {
        this.bookDetail.utcsView.insuranceexpirationdate_fmt = " ";
      }

      if (this.bookDetail.utcsView.creditexpirationdate == null) {
        this.bookDetail.utcsView.creditexpirationdate_fmt = " ";
      }

      if (this.bookDetail.utcsView.expirationdate == null) {
        this.bookDetail.utcsView.expirationdate_fmt = " ";
      }

    }


    if (this.bookDetail.created_date == null) {
      this.bookDetail.created_date_fmt = " ";
    }


    if (this.bookDetail.created_by == null) {
      this.bookDetail.created_by = " ";
    }
    if (this.bookDetail.changed_date == null) {
      this.bookDetail.changed_date_fmt = " ";
    }

    if (this.bookDetail.changed_by == null) {
      this.bookDetail.changed_by = " ";
    }

    if (this.bookDetail.hazardous == "1") {
      this.bookDetail.hazardousFmt = "Yes";
    } else {
      this.bookDetail.hazardousFmt = "No";
    }
    if (this.bookDetail.reefer == "1") {
      this.bookDetail.reeferFmt = "Yes";
    } else {
      this.bookDetail.reeferFmt = "No";
    }

    for (var jj of this.bookDetail.bookingItemViews){
      jj.qty = this.getNiceNumber(jj.qty);
      jj.delivered_qty = this.getNiceNumber(jj.delivered_qty);
      jj.delivered_balance = this.getNiceNumber(jj.delivered_balance);
      if (jj.rcv_limit!=null){
        jj.rcv_limit = this.getNiceNumber(jj.rcv_limit);
      }
      jj.received_qty = this.getNiceNumber(jj.received_qty);
      if (jj.received_balance!=null){
        jj.received_balance = this.getNiceNumber(jj.received_balance);
      }
      if (jj.temp_required_c==null){
        jj.temp_required_cFmt = " ";
      }else{
        jj.temp_required_cFmt = jj.temp_required_c;
      }


      if (jj.temp_required_cFmt == null) {
        jj.temp_required_cFmt = " ";
      } else {
        if (jj.temp_required_f != null) {
          jj.temp_required_cFmt = jj.temp_required_f + "F / ";
        }
        if (jj.temp_required_c != null) {
          jj.temp_required_cFmt = jj.temp_required_cFmt  + jj.temp_required_c + "C";
        }
      }
      var yy = 0;
      jj.reservedCount = "0";
      for (var xx of jj.bookingUnits){
         yy = parseFloat(jj.reservedCount.replace(/,/g, '')) + parseFloat(xx.reserved.replace(/,/g, ''));
      }
      jj.reservedCount = yy.toString();

      if (jj.vent_required_pct==null){
        jj.vent_required_pct = " ";
      }
      if (jj.vent_unit_description==null){
        jj.vent_unit_description = " ";
      }
      if (jj.humidity_required==null){
        jj.humidity_required = " ";
      }

      if (jj.created_date == null) {
        jj.created_fmt = " ";
      }

      if (jj.created_by==null){
        jj.created_by = " ";
      }

      if (jj.changed_date == null) {
        jj.changed_fmt = " ";
      }

      if (jj.changed_by==null){
        jj.changed_by = " ";
      }
      jj.expanded = "N";
    }

    this.formatHazards(0);
   /* if (window.innerWidth<1601){
      this.recBalColName = "Recv. Bal.";
    }else{
      this.recBalColName = "Received Balance";

    }*/

    this.itemsData = new MatTableDataSource<BookingAuthorization>(this.bookDetail.bookingItemViews);
    this.itemsData2 = new MatTableDataSource<BookingAuthorization>(this.bookDetail.bookingItemViews);


  }

  formatHazards(indxIn: number){
    if (indxIn==0){
      this.bookHaz = {} as BookingHazardsView;
      if (this.bookDetail.bookingHazardsViews!=null) {
        if (this.bookDetail.bookingHazardsViews.length > 0) {
          this.bookHaz = this.bookDetail.bookingHazardsViews[0];
        }
      }
    }

    if (this.bookHaz.undg==null){
      this.bookHaz.undg = " ";
    }


    this.bookHaz.undgTypeConcat = this.bookHaz.undg + " - " + this.bookHaz.hzrdi_nbr_type ;

    if (this.bookHaz.long_description==null){
      this.bookHaz.long_description = " ";
    }

    this.bookHaz.imdgConcat = this.bookHaz.hazardcode + " - " + this.bookHaz.long_description;

    if (this.bookHaz.quantity==null){
      this.bookHaz.quantity = " ";
    }else{
      this.bookHaz.quantity = this.getNiceNumber(this.bookHaz.quantity);
    }
    if (this.bookHaz.techname==null){
      this.bookHaz.techname = " ";
    }
    if (this.bookHaz.proper_name==null){
      this.bookHaz.proper_name = " ";
    }
    if (this.bookHaz.remarks==null){
      this.bookHaz.remarks = " ";
    }
    if (this.bookHaz.packagetype==null){
      this.bookHaz.packagetype = " ";
    }
    if (this.bookHaz.packagegroup==null){
      this.bookHaz.packagegroup = " ";
    }
    if (this.bookHaz.weight==null){
      this.bookHaz.weight_fmt = " ";
    }else{
      this.weightk = " ";
      this.weightlb = " ";
      this.weightk = this.getNiceWeight(this.bookHaz.weight)
      this.weightlb = this.getNiceWeight(this.bookHaz.weight_lbs)
      this.bookHaz.weight_fmt = this.weightk + " kg / " + this.weightlb + " lbs";
    }



    if (this.bookHaz.flashpoint == null) {
      this.bookHaz.flashpoint = " ";
    } else {
      if (this.bookHaz.flashpoint_f != null) {
        this.bookHaz.flashpoint = this.bookHaz.flashpoint_f + "F / ";
      }
      if (this.bookHaz.flashpoint_c != null) {
        this.bookHaz.flashpoint = this.bookHaz.flashpoint  + this.bookHaz.flashpoint_c + "C";
      }
    }

    if (this.bookHaz.emergency_telephone==null){
      this.bookHaz.emergency_telephone_fmt = " ";
    }
    if (this.bookHaz.marinepollutant == "1") {
      this.bookHaz.marinepollutantFmt = "Yes";
    } else {
      this.bookHaz.marinepollutantFmt = "No";
    }
  }

  public wipeOutSearch() {
    this.txtFromArea = null;
    this.showQuickView = false;
    this.showDetailScreen = false;
    this.submitted = false;
  }


  showContainersFromList() {
    var indx = this.listData.findIndex(xx => xx.id == this.savedList);
    if (indx != -1) {
      this.txtFromArea = "";
      for (var ii = 0; ii < this.listData[indx].data.length; ii++) {
        this.txtFromArea = this.txtFromArea + this.listData[indx].data[ii].valueOf() + '\r\n';
      }
    }
  }






  deleteHit() {
    this.myApp.showConfirmBanner("Confirm","confirm delete of list: "+this.savedLists[this.savedLists.findIndex(xx=>xx.id==this.savedList)].description,"bookingInquiry");
    return;
  }

  updateContainerList(fromWhere: string){
    this.submitted = true;
    this.clientRequest = null;
    this.insertNoConts = false;
    this.noListName = false;
    this.insertListExists = false;
    this.clientRequest = {} as ClientRequest;
    this.listDataObj = null;
    this.listDataObj =  {} as ListData;
    if (fromWhere=="D"){
      var indx = this.listData.findIndex(xx => xx.id == this.savedList);
      if (indx!=-1){
        this.listDataObj = this.listData[indx];
      }
      this.listDataObj.data = [];
      this.clientRequest.requestData = [];
      this.clientRequest.requestData[0] = this.listDataObj;
    }else{
      if (this.txtFromArea==undefined || this.txtFromArea==""){
        if (fromWhere=="I" || fromWhere=="U"){
          this.insertNoConts = true;
        }
        return;
      }
      if ((fromWhere=="I" ) && (this.myNewListName==null || this.myNewListName=="")){
        this.noListName = true;
        return;
      }

      if ((fromWhere=="U" ) && (this.savedList==null || this.savedList=="")){
        this.noListName = true;
        return;
      }


      if (fromWhere=="I" &&  this.listData.findIndex(xx => xx.name == this.myNewListName && xx.type == "B") !=-1){
        this.insertListExists = true;
        return;
      }

      this.txtArray2 = this.txtFromArea.split(/[\r\n]+/);
      if (this.txtArray2.length==0){
        this.didntEnterShit = true;
        return;
      }
      this.didntEnterShit = false;
      var _i = this.txtArray2.length;
      while (_i--) {
        if (this.txtArray2[_i].valueOf() == "") {
          this.txtArray2.splice(_i, 1);
        }
      }

      if (fromWhere!="D"){
        if (fromWhere=="I"){
          this.listDataObj.name = this.myNewListName;
          this.listDataObj.type = "B";
        }else{
          var indx = this.listData.findIndex(xx => xx.id == this.savedList);
          if (indx!=-1){
            this.listDataObj = this.listData[indx];
          }
        }
        this.listDataObj.data = this.txtArray2;
        this.clientRequest.requestData = [];
        this.clientRequest.requestData[0] = this.listDataObj;
      }
    }

    this.clientRequest.user = this.myUser;

    const lhsUserObs$ = this.queryService.updateContainerList(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (lstConts) => {
        this.listData = lstConts;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
        var id = this.savedList;
        this.fillUpSavedLists();
        if (this.savedLists.length > 0) {
          if (fromWhere == "I") {
            this.savedList = this.savedLists[this.savedLists.findIndex(xx=> xx.code == this.myNewListName)].id;
          } else if (fromWhere== "D") {
            this.savedList = this.savedLists[0].id;
          }else{
            this.savedList = this.savedLists[this.savedLists.findIndex(xx=> xx.id == id)].id;
          }
        }
        this.myNewListName = "";

        if (fromWhere=="I"){
          this.myApp.showSuccessBanner("","the new list has been created successfully","bookingInquiry");
        }else if (fromWhere=="D"){
          this.myApp.showSuccessBanner("",this.myNewListName + " has been deleted successfully","bookingInquiry");
        }else{
          this.myApp.showSuccessBanner("","List has been updated successfully","bookingInquiry");

        }

        this.submitted= false;



      });

  }


  getListData() {
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];

    this.listData = []
    this.listDataObj = {} as ListData;
    this.listDataObj.type = "B";
    this.listData.push(this.listDataObj);
    this.clientRequest.requestData = [];
    this.clientRequest.requestData = this.listData;

    const lhsUserObs$ = this.queryService.getLists(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (lstConts) => {
        this.listData = lstConts;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
          this.fillUpSavedLists();
      });

  }

  fillUpSavedLists(){
    this.savedLists = [];
    for (var item of this.listData){
      if (item.type =="B"){
        this.savedLists.push({"id": item.id, "code": item.name, "description": item.name});
      }
    }
    if (this.savedLists.length>0){
      this.savedList = this.savedLists[0].id;
    }
  }

  ngAfterViewInit(): void {
    this.search1 = new UntypedFormControl();
    this.getListData();
    this.bookDetail = {} as BookingsView;

    if (window.innerWidth > 750 && window.innerWidth <1150){
      this.ipadApp = true;
    }
    if (window.innerWidth <= 750){
      this.phoneApp = true;
    }
  }

}


